import React from 'react';
import esriStrings from '../../resources/esriStrings';
import './splashModal.scss';
import LocationSearch from '../header/locationSearch';
import InfoTooltip from '../bitsnbobs/info-tooltip';

const SplashModal = (props) => {
  const handleZipSearch = (zipcode) => {
    props.handleSearch();
  };
  const handleValidSearch = () => {
    
    props.setShowSplash(false);
  };
  const handleInvalidSearch = (err) => {
    
    alert('Invalid Search');
  };

  return props.isVisible
    ? <div className="splash-modal">
      <div className="splash-modal-content">
        <h1 className="splash-modal-title">
          {esriStrings.splashTitle}
          <sup>SM</sup>
        </h1>
        {/* <div className="info-icon">{props.hideToolTip?null:<InfoTooltip title = {props.info}></InfoTooltip>}</div> */}
        <p className="splash-modal-subtitle not-mobile">
          {esriStrings.splashSubTitle}
        </p>
        <p className="splash-modal-bodytext not-mobile">
          {esriStrings.splashBody}
        </p>
        <p className="splash-modal-mobile-copy on-mobile">
          {esriStrings.splashMobileBody}
        </p>
        <LocationSearch
          passSearchPoint={props.passSearchPoint}
          onValidSearch={handleValidSearch}
          onInvalidSearch={handleInvalidSearch}
          esriView={props.esriView}
          satTitle="splash"
        ></LocationSearch>
      </div>
    </div>
   : null;
};

export default SplashModal;
